import { createContext } from "react"

export interface AiContextValue {
  modelId: string | null | undefined
  instrument: unknown
  base: unknown
  startDate: unknown
  endDate: unknown
  isPreferencesLoaded: boolean
  canPinArtifacts?: boolean
  nudgeScopeKey?: string
}

export const AiContext = createContext<AiContextValue | null>(null)
